export const ORDER_CUSTOMER_LOG_EXPORT_ID = 'order-customer-log';
export const ORDER_CUSTOMER_LOG_TITLE = 'Pedidos Modificados de Clientes';

export const LOCALIZED_PROPERTIES = {
  code: 'Codigo_Ruta',
  subRoute: 'Ruta',
  user: 'Usuario',
  serial: 'Nro Doc',
  date: 'Fecha',
  shipToExternalKey:'Codigo_Cliente',
  shipToName: 'Cliente',
  materialCode: 'Codigo_Material',
  materialName: 'Material',
  soldQuantityBefore: 'Cantidad Antes',
  soldQuantity: 'Cantidad Despues',
  baseUnitOfMeasureCode: 'UMB',
  pararellQuantityBefore: 'Cantidad UMP Antes',
  pararellQuantity: 'Cantidad UMP Despues',
  pararellUnitOfMeasureCode: 'UMP',
  alternalQuantityBefore: 'Cantidad UMA antes',
  alternalQuantity: 'Cantidad UMA después',
  alternalUnitOfMeasureCode: 'UMA',
  unitPriceBefore: 'Precio antes',
  unitPrice: 'Precio después',
  subTotalBefore: 'Subtotal antes',
  totalBefore: 'Total antes',
  subTotal: 'Subtotal después',
  total: 'Total después',
  deleted: 'Eliminado',
  createDateTimeDate: 'Fecha de Creación',
  createDateTimeHour: 'Hora de Creación',
};
